import { makeAutoObservable } from "mobx";

export default class Analysis {
  isPreBase = "";
  period = "";
  actualCost = "";
  actualCostPeriod = "";
  actualProgress = "";
  budgetAtCompletion = "";
  budgetSpent = "";
  costPerformanceIndex = "";
  costPerformanceIndexPeriod = "";
  costVariance = "";
  earnedSchedule = "";
  earnedSchedulePeriod = "";
  earnedValue = "";
  earnedValuePeriod = "";
  forecastedProgress = "";
  forecastedCost = "";
  forecastedCostPeriod = "";
  forecastAtCompletionMean = "";
  forecastAtCompletionStDev = "";
  note = "";
  plannedProgress = "";
  plannedValue = "";
  plannedValuePeriod = "";
  schedulePerformanceIndexCost = "";
  schedulePerformanceIndexCostPeriod = "";
  schedulePerformanceIndexTime = "";
  schedulePerformanceIndexTimePeriod = "";
  scheduleVarianceCost = "";
  scheduleVarianceTime = "";
  varianceAtCompletionMean = "";

  constructor() {
    makeAutoObservable(this);
  }

  toJS() {
    let plainObject = {};
    plainObject.isPreBase = this.isPreBase;
    plainObject.period = this.period;
    plainObject.actualCost = this.actualCost;
    plainObject.actualCostPeriod = this.actualCostPeriod;
    plainObject.actualProgress = this.actualProgress;
    plainObject.budgetAtCompletion = this.budgetAtCompletion;
    plainObject.budgetSpent = this.budgetSpent;
    plainObject.costPerformanceIndex = this.costPerformanceIndex;
    plainObject.costPerformanceIndexPeriod = this.costPerformanceIndexPeriod;
    plainObject.costVariance = this.costVariance;
    plainObject.earnedSchedule = this.earnedSchedule;
    plainObject.earnedSchedulePeriod = this.earnedSchedulePeriod;
    plainObject.earnedValue = this.earnedValue;
    plainObject.earnedValuePeriod = this.earnedValuePeriod;
    plainObject.forecastedCost = this.forecastedCost;
    plainObject.forecastedCostPeriod = this.forecastedCostPeriod;
    plainObject.forecastedProgress = this.forecastedProgress;
    plainObject.forecastAtCompletionMean = this.forecastAtCompletionMean;
    plainObject.forecastAtCompletionStDev = this.forecastAtCompletionStDev;
    plainObject.note = this.note;
    plainObject.plannedProgress = this.plannedProgress;
    plainObject.plannedValue = this.plannedValue;
    plainObject.plannedValuePeriod = this.plannedValuePeriod;
    plainObject.schedulePerformanceIndexCost =
      this.schedulePerformanceIndexCost;
    plainObject.schedulePerformanceIndexCostPeriod =
      this.schedulePerformanceIndexCostPeriod;
    plainObject.schedulePerformanceIndexTime =
      this.schedulePerformanceIndexTime;
    plainObject.schedulePerformanceIndexTimePeriod =
      this.schedulePerformanceIndexTimePeriod;
    plainObject.scheduleVarianceCost = this.scheduleVarianceCost;
    plainObject.scheduleVarianceTime = this.scheduleVarianceTime;
    plainObject.varianceAtCompletionMean = this.varianceAtCompletionMean;
    plainObject.budgetedRateForecast = this.budgetedRateForecast;
    return plainObject;
  }

  static fromJS(savedState) {
    const analysis = new Analysis();
    if (savedState != null) {
      analysis.isPreBase = savedState.isPreBase;
      analysis.period = savedState.period;
      analysis.actualCost = savedState.actualCost;
      analysis.actualCostPeriod = savedState.actualCostPeriod;
      analysis.actualProgress = savedState.actualProgress;
      analysis.budgetAtCompletion = savedState.budgetAtCompletion;
      analysis.budgetSpent = savedState.budgetSpent;
      analysis.costPerformanceIndex = savedState.costPerformanceIndex;
      analysis.costPerformanceIndexPeriod =
        savedState.costPerformanceIndexPeriod;
      analysis.costVariance = savedState.costVariance;
      analysis.earnedSchedule = savedState.earnedSchedule;
      analysis.earnedSchedulePeriod = savedState.earnedSchedulePeriod;
      analysis.earnedValue = savedState.earnedValue;
      analysis.earnedValuePeriod = savedState.earnedValuePeriod;
      analysis.forecastedCost = savedState.forecastedCost;
      analysis.forecastedCostPeriod = savedState.forecastedCostPeriod;
      analysis.forecastedProgress = savedState.forecastedProgress;
      analysis.forecastAtCompletionMean = savedState.forecastAtCompletionMean;
      analysis.forecastAtCompletionStDev = savedState.forecastAtCompletionStDev;
      analysis.note = savedState.note;
      analysis.plannedProgress = savedState.plannedProgress;
      analysis.plannedValue = savedState.plannedValue;
      analysis.plannedValuePeriod = savedState.plannedValuePeriod;
      analysis.schedulePerformanceIndexCost =
        savedState.schedulePerformanceIndexCost;
      analysis.schedulePerformanceIndexCostPeriod =
        savedState.schedulePerformanceIndexCostPeriod;
      analysis.schedulePerformanceIndexTime =
        savedState.schedulePerformanceIndexTime;
      analysis.schedulePerformanceIndexTimePeriod =
        savedState.schedulePerformanceIndexTimePeriod;
      analysis.scheduleVarianceCost = savedState.scheduleVarianceCost;
      analysis.scheduleVarianceTime = savedState.scheduleVarianceTime;
      analysis.varianceAtCompletionMean = savedState.varianceAtCompletionMean;
      analysis.budgetedRateForecast = savedState.budgetedRateForecast;
    }
    return analysis;
  }
}


